<p-toast [baseZIndex]="9999" position="top-left"></p-toast>
<div class="container-fluid">
  <div class="card-panel mt-5 mb-5">
    <div class="row">
      <div class="col-md-5">
        <lib-page-header page-title="ORDEM DE FORNECIMENTO" image-title="assets/img/commerce-and-shopping.png"
          page-subtitle="EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}">
        </lib-page-header>
      </div>
      <div class="col-md-7">
        <button type="button" (click)="sair()" class="btn btn-sm btn-outline-secondary float-right  ml-5">
          <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="20" width="20">
        </button>
        <lib-export-list (acao)="exportarListagem($event)"></lib-export-list>
        <a *ngIf="podeIncluir()" [routerLink]="['/compras/novo']" class="btn btn-sm btn-outline-success float-right">
          <img src="assets/img/global/plus.png" alt="novo" class="mr-2" title="Incluir" height="20" width="20">Novo
        </a>
      </div>
    </div>
    <hr class="mt-2 mb-4" />
    <div class="row">
      <div class="col-md-6">
        <lib-filtro [(filtro)]="filtro" (localizaClick)="onClick($event)" (localizaKeydown)="onClick($event)">
        </lib-filtro>
      </div>
    </div>
    <div class="row" *ngIf="lista && lista.length === 0">
      <div class="col-12">
        <em class="fa fa-exclamation-triangle text-black-50" style="font-size: 20px"></em>
        <span class="text-black-50 ml-1">Não foram encontrados registros cadastrados!</span>
      </div>
    </div>
    <div class="row" *ngIf="lista && lista.length > 0">
      <div class="col-md-12">
        <div class="table-responsive">
          <table class="table table-eddy">
            <thead>
              <tr>
                <th scope="col" style="width: 10%;">Nº/Exercício</th>
                <th scope="col" style="width: 10%;" class="text-center">Data</th>
                <th scope="col" style="width: 10%;" class="text-center">Requisição</th>
                <th scope="col" style="width: 30%;">Fornecedor</th>
                <th scope="col" style="width: 10%;" class="text-center">Subelemento</th>
                <th scope="col" style="width: 25%;">Requerente</th>
                <th scope="col" style="width: 15%;" class="text-center">Valor Total</th>
                <th scope="col" style="width: 10%;"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of lista" class="{{item.excluido ? 'linha-cancelada': ''}}">
                <th scope="row">
                  <div class="d-flex flex-column">
                    <strong>{{("00000" + item.numero).slice(-5)}}/{{item.exercicio.ano}}</strong>
                    <span *ngIf="item.empenho" class="text-primary" style="font-size: 10px;">Em.:
                      {{("00000" + item.empenho.numero).slice(-5) }}/{{item.empenho.exercicio.ano}}</span>
                  </div>
                </th>
                <td class="text-center">{{item.data_compra | date:'dd/MM/yyyy':'GMT'}}</td>
                <td class="text-center">{{item?.rcms?.numero}}</td>
                <th scope="row">
                  <div class="d-flex flex-column">
                    {{item.favorecido.nome}}
                    <span *ngIf="item.favorecido" class="text-secondary" style="font-size: 10px;">CPF/CNPJ:
                      {{item.favorecido.cpf_cnpj | CPF}}</span>
                  </div>
                </th>
                <td class="text-center">{{item.subelemento.codigo | mascarar : '0.0.00.00.00.000'}}</td>
                <td>{{item.requerente?.nome}}</td>
                <td class="text-center">
                  {{item.total_compra | number:'1.5-5'}}
                </td>
                <td class="text-right">
                  <button *ngIf="!podeIncluir() || item.excluido || item?.empenho?.id" [routerLink]="['/compras', item.id, 'visualizar']"
                    routerLinkActive="router-link-active" class="btn btn-sm btn-outline-secondary mr-2 float-right">
                    <img src="assets/img/global/zoom.png" alt="visualizar" height="18" width="18">
                  </button>
                  <button *ngIf="podeIncluir() && !item.excluido && !item?.empenho?.id" [routerLink]="['/compras', item.id, 'editar']"
                    routerLinkActive="router-link-active" class="btn btn-sm btn-primary mr-2">
                    <img src="assets/img/global/pencil.png" alt="editar" height="18" width="18">
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="row float-right" *ngIf="lista && lista.length > 0">
      <div class="col-12 mb-5">
        <lib-paginacao [(paginaCorrente)]="paginaCorrente" [(paginaTotal)]="paginaTotal"
          (paginaAnterior)="paginaAnterior()" (proximaPagina)="proximaPagina()"></lib-paginacao>
      </div>
    </div>
    <br>
    <br>
  </div>
</div>